module.exports = __webpack_public_path__ + "static/media/about.7986e729.jpg";